import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/mirofish/world-cup-prediction-page.tsx");
